document.addEventListener("DOMContentLoaded", () => {
  const observer = new MutationObserver(() => {
    if (!document.body.hasAttribute("data-product-cards-slider")) {
      return;
    }
    observer.disconnect();
    document
      .querySelectorAll(".card .card__slider .splide")
      .forEach((slider) => {
        new Splide(slider, {
          type: "loop",
          pagination: false,
          mediaQuery: "min",
          breakpoints: {
            768: {
              destroy: true,
            },
          },
        }).mount();
      });
  });
  observer.observe(document.body, {
    attributes: true,
    childList: false,
    subtree: false,
  });
});
